import { motion } from "framer-motion";
import { ProductVariant } from "@/data/productLines";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";

interface VariantToggleProps {
  variants: ProductVariant[];
  activeVariantId: string;
  onVariantChange: (variantId: string) => void;
}

const VariantToggle = ({ variants, activeVariantId, onVariantChange }: VariantToggleProps) => {
  if (variants.length <= 1) return null;

  return (
    <div className="inline-flex items-center gap-1 p-1 bg-muted/50 rounded-full border border-border/50">
      {variants.map((variant) => {
        const isActive = variant.id === activeVariantId;
        return (
          <button
            key={variant.id}
            onClick={() => onVariantChange(variant.id)}
            className={cn(
              "relative px-4 py-2 rounded-full text-sm font-medium transition-colors",
              isActive
                ? "text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {isActive && (
              <motion.div
                layoutId="variant-pill"
                className="absolute inset-0 bg-primary rounded-full"
                transition={{ type: "spring", bounce: 0.2, duration: 0.4 }}
              />
            )}
            <span className="relative z-10 flex items-center gap-2">
              {variant.name}
              {variant.priceIndicator === "premium" && (
                <Badge variant="secondary" className="text-[10px] px-1.5 py-0">
                  PRO
                </Badge>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default VariantToggle;
